// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `section.deal-upsell-modal {
  padding: 20px;
}

section.deal-upsell-modal ul {
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: calc(100vh - 185px);
  overflow-y: auto;
  overflow-x: hidden;
  margin-top: -5px;
}

.upsell-option {
  font-size: 14px;
  border: thin solid rgba(0, 0, 0, 0.12);
  margin: 5px 0 10px;
  padding: 20px;
  width: 100%;
  text-align: center;
  cursor: pointer;
  border-radius: 8px;
  list-style: none;
  background-color: #ffe6cc;
}
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
